import { Model } from "@vuex-orm/core";

export class MCardType extends Model {
    static get entity() {
        return "m_cardtypes"
    }

    static fields() {
        return {
            "id": this.attr(null),
            "m_cardtype_name": this.string(""),
            "create_by": this.attr(null),
            "update_by": this.attr(null),
            "createdAt": this.attr(null),
            "updatedAt": this.attr(null)
        }
    }

    static get apiConfig() {
        return {
            actions: {
                findAll(params = {}) {
                    return this.get('/m_cardtype', { params });
                }
            }
        };
    }
}